import { Reducer } from 'redux';
import { produce } from 'immer';
import { statusList, movementList } from 'utils/statusList';
import { MANAGEMENT_TYPES, ManagementState } from './types';

const today = new Date();
const lastWeek = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);

export const INITIAL_STATE: ManagementState = {
  movement: {
    tableA: {
      data: null,
      filter: {
        dates: [lastWeek, today],
        status: movementList[0].value,
      },
    },
    tableB: {
      data: null,
      filter: {
        dates: [lastWeek, today],
        status: movementList[1].value,
      },
    },
    tableC: {
      data: null,
      filter: {
        dates: [lastWeek, today],
        status: movementList[2].value,
      },
    },
  },
  status: {
    tableA: {
      data: null,
      filter: {
        dates: [lastWeek, today],
        status: statusList[0].value,
      },
    },
    tableB: {
      data: null,
      filter: {
        dates: [lastWeek, today],
        status: statusList[1].value,
      },
    },
    tableC: {
      data: null,
      filter: {
        dates: [lastWeek, today],
        status: statusList[2].value,
      },
    },
  },
};

const reducer: Reducer<ManagementState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case MANAGEMENT_TYPES.CLEAR_DATA_TABLE:
        draft.movement[action.payload.table].data = null;
        break;
      case MANAGEMENT_TYPES.SET_DATA_TABLE:
        if (action.payload.type === 'movement') {
          draft.movement[action.payload.table].data = action.payload.data;
        } else {
          draft.status[action.payload.table].data = action.payload.data;
        }
        break;
      case MANAGEMENT_TYPES.SET_FILTER_STATUS_TABLE:
        if (action.payload.type === 'movement') {
          draft.movement[action.payload.table].filter.status =
            action.payload.filter;
        } else {
          draft.status[action.payload.table].filter.status =
            action.payload.filter;
        }
        break;
      case MANAGEMENT_TYPES.SET_FILTER_DATE_TABLE:
        if (action.payload.type === 'movement') {
          draft.movement[action.payload.table].filter.dates =
            action.payload.filter;
        } else {
          draft.status[action.payload.table].filter.dates =
            action.payload.filter;
        }
        break;
      default:
    }
  });
};

export default reducer;
